var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4998 15.1998C11.4763 15.1998 14.6998 11.9763 14.6998 7.9998C14.6998 4.02335 11.4763 0.799805 7.4998 0.799805C3.52335 0.799805 0.299805 4.02335 0.299805 7.9998C0.299805 11.9763 3.52335 15.1998 7.4998 15.1998ZM4.7998 7.0998C5.29686 7.0998 5.6998 6.69686 5.6998 6.1998C5.6998 5.70275 5.29686 5.2998 4.7998 5.2998C4.30275 5.2998 3.8998 5.70275 3.8998 6.1998C3.8998 6.69686 4.30275 7.0998 4.7998 7.0998ZM11.0998 6.1998C11.0998 6.69686 10.6969 7.0998 10.1998 7.0998C9.70275 7.0998 9.2998 6.69686 9.2998 6.1998C9.2998 5.70275 9.70275 5.2998 10.1998 5.2998C10.6969 5.2998 11.0998 5.70275 11.0998 6.1998ZM10.6818 11.1817C11.0333 10.8302 11.0333 10.2604 10.6818 9.90891C10.3303 9.55744 9.76047 9.55744 9.40899 9.90891C8.35458 10.9633 6.64503 10.9633 5.59062 9.90891C5.23914 9.55744 4.6693 9.55744 4.31782 9.90891C3.96635 10.2604 3.96635 10.8302 4.31782 11.1817C6.07518 12.9391 8.92443 12.9391 10.6818 11.1817Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.f97e00534dab0748623d6294c53d19ac.svg";
export { ForwardRef as ReactComponent };